module.exports = __webpack_public_path__ + "static/2006-counsel-696e0411f37c0a13b73b0748b19b1250.jpg";